// src/components/vault/EditDocDialog.jsx  (UPDATED: inline loader)
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, TextField, MenuItem, Button, CircularProgress } from "@mui/material";

const CATEGORIES = [
    { key: "legal", label: "Legal & Identity Documents" },
    { key: "education", label: "Education & Board Certification Documents" },
    { key: "licenses", label: "Medical Licenses" },
    { key: "resuscitation", label: "Resuscitation Documents" },
    { key: "logs", label: "Procedure/Case Logs" },
    { key: "employment", label: "Employment Documents" },
    { key: "health", label: "Health & Immunization Documents" },
    { key: "other", label: "Other/Miscellaneous Documents" },
];

export default function EditDocDialog({ open, doc, onClose, onSubmit }) {
    const [name, setName] = React.useState(doc?.name || "");
    const [category, setCategory] = React.useState(doc?.category || "other");
    const [expires, setExpires] = React.useState(doc?.expiresAt ? new Date(doc.expiresAt).toISOString().slice(0,10) : "");
    const [saving, setSaving] = React.useState(false);

    React.useEffect(() => {
        if (open) {
            setName(doc?.name || "");
            setCategory(doc?.category || "other");
            setExpires(doc?.expiresAt ? new Date(doc.expiresAt).toISOString().slice(0,10) : "");
            setSaving(false);
        }
    }, [open, doc]);

    if (!open) return null;

    const handleSave = async () => {
        setSaving(true);
        try {
            await onSubmit?.({ id: doc.id, name, category, expiresAt: expires || null });
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Edit Document</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={1.5}>
                    <TextField label="Document Name" size="small" value={name} onChange={(e) => setName(e.target.value)} disabled={saving} />
                    <TextField select size="small" label="Category" value={category} onChange={(e) => setCategory(e.target.value)} disabled={saving}>
                        {CATEGORIES.map((c) => <MenuItem key={c.key} value={c.key}>{c.label}</MenuItem>)}
                    </TextField>
                    <TextField
                        size="small" type="date" label="Expiration date (optional)" InputLabelProps={{ shrink: true }}
                        value={expires} onChange={(e) => setExpires(e.target.value)} disabled={saving}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={saving}>Cancel</Button>
                <Button variant="contained" onClick={handleSave} disabled={saving}>
                    {saving ? <CircularProgress size={18} sx={{ color: "white" }} /> : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}